import { useT } from "@/i18n";
import { toastsMessages } from "@/i18n/messages/toasts";
import type { WorkToastComputerScreenshot } from "@/stores/work-toast-store";

/** The latest screen capture of a run driving the computer. The displays of
 *  one capture share the width; the next capture replaces them. */
export function WorkToastScreenshotBody({
  screenshots,
}: {
  screenshots: WorkToastComputerScreenshot[];
}) {
  const t = useT(toastsMessages);
  return (
    <div
      className="flex gap-1"
      role="img"
      aria-label={t("latestScreenshot")}
      data-testid="work-toast-screenshot-body"
    >
      {screenshots.map((shot) => (
        <img
          key={`${shot.captureId}:${shot.displayId ?? shot.ordinal}`}
          src={shot.url}
          alt=""
          className="h-[124px] min-w-0 flex-1 rounded-preview bg-[var(--color-surface-selected)] object-cover"
          data-testid="work-toast-screenshot"
        />
      ))}
    </div>
  );
}
